import React, { useState } from "react";
import "react-dropzone-uploader/dist/styles.css";
import Dropzone from "react-dropzone-uploader";
import Axios from "../axios";

const ACCOUNT_WITH_SINGLE_BVN = ["Current", "Savings"];

const DragAndDropUpload = ({
  fileInfo,
  type,
  disabled,
  path,
  objKey,
  setState,
  isUploading,
  callback,
  myObjects,
}) => {
  let content = <p>Image.png</p>;

  // const trimStr = (str) => {
  //   if (str !== null && str !== undefined) {
  //     return str.trim();
  //   }
  //   return "";
  // };

  const cusId = sessionStorage.getItem("customerid");
  const bvnData = JSON.parse(sessionStorage.getItem("res"));
  const accountType = "savings" || "current";

  const accountName = `${bvnData?.FirstName}${bvnData?.FirstName}`;
  // console.log({ accountType, accountName });

  const [objects, setObjects] = useState({
    fileName: "",
    meta: "",
    status: "",
    display: false,
  });

  const [allFormData, setAllFormData] = useState([]);

  const [textContent, setTextContent] = useState(
    "No files uploaded for this validation yet"
  );

  // console.log("My Objects: ", objects);
  // console.log({allFormData})

  // const uploadImage = (file) => {
  //   setState((prevS) => ({
  //     ...prevS,
  //     isUploading: true,
  //   }));

  //   const formData = new FormData();

  //   formData.append("idCardName", "Individual Account");
  //   formData.append("idCardName", objKey);
  //   formData.append("AccountName", accountName);
  //   formData.append("customerid", cusId);
  //   formData.append("file", file);

  //   Axios.post("/docUpload", formData)
  //     .then(() => {
  //       setState((prevS) => ({
  //         ...prevS,
  //         [objKey]: {
  //           ...prevS[objKey],
  //           isUploaded: true,
  //           succrssMsg: "File uploaded successfully",
  //           errorMsg: "",
  //         },
  //       }));

  //       if (callback) {
  //         callback();
  //       }
  //     })
  //     .catch((err) => {
  //       setState((prevS) => ({
  //         ...prevS,
  //         [objKey]: {
  //           ...prevS[objKey],
  //           isUploaded: false,
  //           errorMsg: err?.response?.message || "file upload failed",
  //         },
  //       }));
  //     })
  //     .finally(() => {
  //       setState((prevS) => ({
  //         ...prevS,
  //         isUploading: false,
  //       }));
  //     });

  //   return null;
  // };
  const getUploadParams = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };

  const handleFileChangeStatus = ({ meta, file }, status) => {
    const trimStr = (str) => {
      if (str !== null && str !== undefined) {
        return str.trim();
      }
      return "";
    };
  
    const _formData = new FormData();
    // console.log({ file, _formData });
    if (file) {
      setObjects((prevS) => ({
        ...prevS,
        fileName: file,
        meta: meta,
        status: status,
        display: true,
      }));
    }
    if (status === "uploading") {
      setState((prevS) => ({
        ...prevS,
        isUploading: true,
      }));
      setTextContent(
        <p className="text-warning">{"your file is uploading..... "}</p>
      );
    } else if (status === "done") {
      // console.log(status, "status inner");
      setTextContent(
        <p className="text-success">
          [
          <strong className="text-black text-sm">{`${trimStr(
            objects.fileName.name
          )}`}</strong>
          ]{` Upload Successful`}
        </p>
      );
      setAllFormData((prevS) => [...prevS, objects.meta]);
      setTimeout(() => {
        setState((prevS) => ({
          ...prevS,
          isUploading: false,
          [objKey]: {
            ...prevS[objKey],
            isUploaded: true,
            successMsg: "",
            errorMsg: "",
            fileName: file,
            meta: meta,
            status: status,
            accountName: accountName,
            display: false,
          },
        }));

        if (callback) {
          callback();
        }
      }, 3000);
    } else if (status === "removed") {
      setState((prevS) => ({
        ...prevS,
        [objKey]: {
          ...prevS[objKey],
          isUploaded: false,
          successMsg: "",
          errorMsg: "",
        },
      }));
      setTextContent(
        <p className="text-danger">
          {`Please re-upload a new file to complete ${bvnData?.FirstName}'s document upload`}
        </p>
      );
    } else {
      setState((prevS) => ({
        ...prevS,
        [objKey]: {
          ...prevS[objKey],
          isUploaded: false,
          successMsg: "",
          errorMsg: "",
        },
      }));
      setTextContent(
        <p className="text-warning">{"error uploading file, kindly retry..... "}</p>
      );
    }
  };

  return (
    <>
      <Dropzone
        disabled={disabled}
        onChangeStatus={handleFileChangeStatus}
        // getUploadParams={getUploadParams}
        accept={
          type === "ImageOnly"
            ? "image/*"
            : type === "PdfsOnly"
            ? ".pdf"
            : type === "AllFileTypes"
            ? "image/*, .pdf"
            : "image/png, image'jpg, image/jpeg, .pdf"
        }
        maxFiles={1}
        multiple={false}
        maxSizeBytes={1024 * 1024 * 5}
        submitButtonContent={null}
        SubmitButtonComponent={null}
        inputWithFilesContent={null}
        inputContent={disabled ? path : "Drag or Drop documents/files here"}
        styles={{
          dropzone: {
            minHeight: "60px",
            maxHeight: "60px",
            // maxWidth: "75%",
            width: {
              xs: 290,
              sm: 290,
              md: 500,
              lg: 500,
            },
            overflow: "hidden",
            fontFamily: "Garamond",
            fontWeight: "none",
            backgroundColor: "#F4F5F7",
            borderRadius: "6px",
          },
          previewImage: {
            height: "100%",
            margin: "20px",
            marginTop: "50px",
            marginLeft: "4px",
            border: "none",
          },
          previewButton: {
            margin: "20px 0px 2px 10px",
          },
          dropzoneActive: {
            color: "red",
            fontSize: "2px",
          },
          inputLabel: {
            fontSize: "5px",
            opacity: "20%",
            color: "#1b1b1b",
          },
        }}
      />
      {textContent}
      {/* {fileInfo?.status === "done" ? trimStr(fileInfo?.meta?.name) : ""} */}
    </>
  );
};

export default DragAndDropUpload;

// Driver's License: AAA00000AA00

// International Passport: A11111111

// Voter's Card: 00A0A0A000000000000

// NIN: YV111111111111FY
